export const canvasMenuSelector = state => state.canvasMenu
